import ProjectDetail from './ProjectDetail';
export default ProjectDetail;